export default "__VITE_ASSET__D0CAya$A__"